module.exports = __webpack_public_path__ + "img/web-logo.44f10765.png";